import AxiosIdist from "./AxiosIdist";

class ModelIdist {

  constructor(resource) {
    this.resource = resource;
  }

  get() {
    return AxiosIdist.get(`${this.resource}`);
  }

  getId(id) {
    return AxiosIdist.get(`${this.resource}/?id=${id}`);
  }

  getParams(params) {
    return AxiosIdist.get(`${this.resource}`, { params: params });    
  }

  create(params) {
    return AxiosIdist.post(`${this.resource}/`, params);
  }

  update(id, params) {
    return AxiosIdist.put(`${this.resource}/${id}/`, params);
  }

  delete(id) {
    return AxiosIdist.delete(`${this.resource}/${id}`);
  }

}

export default ModelIdist;
